import React from 'react';
import { CardTitle, CardSubhead } from '@spark/ui-components/components/Card';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import styled from 'styled-components';

const ViagensHeader = ({ totalRegistros, onAdicionar }) => {
  return (
    <HeaderWrap>
      <div>
        <CardTitle>Viagens</CardTitle>
        <CardSubhead>Total de registros: {totalRegistros}</CardSubhead>
      </div>
      <ButtonContainer>
        <ButtonWithLoading variant="primary" onClick={onAdicionar}>
          Adicionar
        </ButtonWithLoading>
      </ButtonContainer>
    </HeaderWrap>
  );
};

export default ViagensHeader;

// Estilos
const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
